import { createContext, useContext, type FC, type ReactNode } from "react"
import type { SectionSurfaceTone } from "~/helpers/colorSurface"

export type { SectionSurfaceTone } from "~/helpers/colorSurface"

export const SectionSurfaceToneContext =
  createContext<SectionSurfaceTone | null>(null)

/**
 * Tone from the enclosing Section canvas (e.g. carousel nav). Outside any Section,
 * returns null so Carousel can fall back to legacy customization.
 */
export function useSectionSurfaceTone(): SectionSurfaceTone | null {
  return useContext(SectionSurfaceToneContext)
}

/** Override inferred tone for nested content (nested Section or Storybook demos). */
export const SectionSurfaceToneSubtree: FC<{
  tone: SectionSurfaceTone
  children?: ReactNode
}> = ({ tone, children }) => (
  <SectionSurfaceToneContext.Provider value={tone}>
    {children}
  </SectionSurfaceToneContext.Provider>
)
